import { render } from "./FormFilterTagsComponent.vue?vue&type=template&id=8741ceec&scoped=true"
import script from "./FormFilterTagsComponent.vue?vue&type=script&lang=js"
export * from "./FormFilterTagsComponent.vue?vue&type=script&lang=js"

import "./FormFilterTagsComponent.vue?vue&type=style&index=0&id=8741ceec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8741ceec"]])

export default __exports__